var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgDesktop = function SvgDesktop(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 97,
    viewBox: "0 0 111 97",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.701,
    d: "M80.995 96H69.349L66 76h25M30.005 96H41.651L45 76H20M99.048 71H11.952C5.928 71 1 66.026 1 59.947V12.053C1 5.973 5.928 1 11.952 1h87.096C105.072 1 110 5.974 110 12.053v47.894C110 66.027 105.072 71 99.048 71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB2F16",
    d: "M56 51c8.837 0 16-7.163 16-16s-7.163-16-16-16c-8.836 0-16 7.163-16 16s7.164 16 16 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M53.939 41a2.566 2.566 0 0 1-1.79-.722L48 36.223l.65-.635 4.147 4.055a1.642 1.642 0 0 0 2.436-.172L63.266 29l.734.538-8.033 10.472a2.554 2.554 0 0 1-2.028.99"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/desktop.d497f330.svg";
export { ForwardRef as ReactComponent };